export default __webpack_public_path__ + "static/media/servicess.de128247.png";